import React from 'react';

import { ICombo, IItem, IPicker } from '@rbi-ctg/menu';
import FormatMenuPrice from 'components/menu-utils/format-menu-price';

import { MainMenuObject } from './types';

interface IFormattedCaloriesAndPriceRangeForMenuObject {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (menuObject: ICombo | IItem | IPicker | MainMenuObject) => string,
    getPrices: (menuObject: ICombo | IItem | IPicker | MainMenuObject) => React.ReactNode
  ): { calories: string; price: React.ReactNode };
}

const formattedCaloriesAndPriceRangeForMenuObject: IFormattedCaloriesAndPriceRangeForMenuObject = (
  menuObject,
  getCaloriesRange,
  getPrices
) => {
  const price = getPrices(menuObject);
  return {
    calories: getCaloriesRange(menuObject),
    price,
  };
};

interface IGetCaloriesAndPrice {
  (
    menuObject: IPicker | MainMenuObject,
    getCaloriesRange: (menuObject: ICombo | IItem) => string
  ): { calories: string; price: React.ReactNode };
}

export const getCaloriesAndPrice: IGetCaloriesAndPrice = (menuObject, getCaloriesRange) => {
  const getPrices = (comboOrItem: ICombo | IItem) => {
    return <FormatMenuPrice menuItem={comboOrItem} />;
  };

  return formattedCaloriesAndPriceRangeForMenuObject(menuObject, getCaloriesRange, getPrices);
};
